import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Select, { components } from 'react-select'

const DropdownIndicator = (props) => (
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            {props.selectProps.menuIsOpen
                ? <i className="fa-regular fa-angle-up" />
                : <i className="fa-regular fa-angle-down" />}
        </components.DropdownIndicator>
    )
)

@observer
class Pagination extends Component {
    pageList = () => {
        const pages = []
        const { dataTableStore } = this.props
        let lastPage = 1
        if (dataTableStore.firstPage > dataTableStore.pageLimit) {
            pages.push(<li key="page_prev" onClick={() => dataTableStore.prevPages()}>...</li>)
        }
        for (let i = dataTableStore.firstPage, round = 1; i <= dataTableStore.pageCount && round <= dataTableStore.pageLimit; i++, round++) {
            const pageClass = (dataTableStore.page === i ? 'selected' : '')
            pages.push(<li key={`page_${round}`} className={pageClass} onClick={() => dataTableStore.changePage(i)}>{i}</li>)
            lastPage = i
        }
        if (lastPage < dataTableStore.pageCount) {
            pages.push(<li key="page_next" onClick={() => dataTableStore.nextPages()}>...</li>)
        }
        return pages
    }

    render() {
        const { dataTableStore } = this.props
        return (
            <div className="pagination">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    {dataTableStore.page > 1
                        && (
                            <span className="elem" onClick={() => dataTableStore.changePage(1)}>
                                <i className="fa-regular fa-angles-left" />
                            </span>
                        )}
                    {dataTableStore.page > 1
                        && (
                            <span className="elem" onClick={() => dataTableStore.changePage(dataTableStore.page - 1)}>
                                <i className="fa-regular fa-angle-left" />
                            </span>
                        )}
                    <ul className="pages">
                        {this.pageList()}
                    </ul>
                    {dataTableStore.page < dataTableStore.pageCount
                        && (
                            <span className="elem" onClick={() => dataTableStore.changePage(dataTableStore.page + 1)}>
                                <i className="fa-regular fa-angle-right" />
                            </span>
                        )}
                    {dataTableStore.page < dataTableStore.pageCount
                        && (
                            <span className="elem" onClick={() => dataTableStore.changePage(dataTableStore.pageCount)}>
                                <i className="fa-regular fa-angles-right" />
                            </span>
                        )}
                </div>

                <div style={{ display: 'flex', gap: 30, alignItems: 'center', justifySelf: 'flex-end' }}>
                    <span className="selector">
                        <Select
                            className="count-select"
                            clearable={false}
                            options={dataTableStore.rowCounts}
                            value={dataTableStore.rowLimit}
                            onChange={dataTableStore.changeRowLimit}
                            isSearchable={false}
                            components={{ DropdownIndicator }}
                            menuPlacement="top"
                        />

                        <p>Items per page</p>
                    </span>

                    <p className="record">
                        {`${dataTableStore.records} of ${dataTableStore.dataLength} items`}
                    </p>
                </div>
            </div>
        )
    }
}

export default Pagination
